import update from 'immutability-helper';
import SignatureAuditButtonConstants from './SignatureAuditButtonConstants';

const initialState = {
  isFetchingAuditSessions: false,
  auditList: [],
};

const SignatureAuditButtonReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case SignatureAuditButtonConstants.SIGNATURE_AUDIT_HISTORY_GET_REQUEST:
      return update(state, {
        isFetchingAuditSessions: { $set: true },
      });
    case SignatureAuditButtonConstants.SIGNATURE_AUDIT_HISTORY_GET_SUCCESS:
    case SignatureAuditButtonConstants.SIGNATURE_AUDIT_HISTORY_GET_FROM_SHARE_KEY_SUCCESS:
      return update(state, {
        auditList: { $set: action.auditList },
        isFetchingAuditSessions: { $set: false },
      });
    case SignatureAuditButtonConstants.SIGNATURE_AUDIT_HISTORY_GET_FAILURE:
      return update(state, {
        isFetchingAuditSessions: { $set: false },
      });
    default:
      return state;
  }
};

export default SignatureAuditButtonReducer;



// WEBPACK FOOTER //
// ./src-react/SignatureAuditButton/SignatureAuditButtonReducer.jsx